export default "https://shopfront-cdn.tekoapis.com/_next/static/images/promotion_combo_vi-f2f6c5da86286804196e5800ebfaafc4.svg";